import * as yup from 'yup'

export const updateProfileFieldSchema = yup.object().shape({
    title: yup.string().required('Введите название поля'),
    required: yup.boolean(),
    type: yup.string().required('Выберите тип поля'),
    min_length: yup.number().typeError('Введите число').optional(),
    max_length: yup.number().typeError('Введите число').optional(),
    min_number: yup.number().typeError('Введите число').optional(),
    max_number: yup.number().typeError('Введите число').optional(),
    min_date: yup.date().optional(),
    max_date: yup.date().optional(),
    allowed_extensions: yup.array().of(yup.string()).optional(),
})